export default __webpack_public_path__ + "static/media/MultimetersImg.c722b839.jpg";